import { render, staticRenderFns } from "./SettingsCopyDialog.vue?vue&type=template&id=5e288996&scoped=true&"
import script from "./SettingsCopyDialog.vue?vue&type=script&lang=js&"
export * from "./SettingsCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e288996",
  null
  
)

export default component.exports